import { render, staticRenderFns } from "./paymentAccountsArchive.vue?vue&type=template&id=1cb78e82&scoped=true"
import script from "./paymentAccountsArchive.vue?vue&type=script&lang=js"
export * from "./paymentAccountsArchive.vue?vue&type=script&lang=js"
import style0 from "./paymentAccountsArchive.vue?vue&type=style&index=0&id=1cb78e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb78e82",
  null
  
)

export default component.exports